<template>
  <div class="bingli">
    <div class="bingli-title">
      <titleCard title="肾内病例征集"></titleCard>
    </div>
    <div class="content">
      <div class="left animate__animated wow animate__fadeInLeft">
        <div class="txtbox">
          <h4>主办单位</h4>
          <p>国家卫生健康委能力建设和继续教育中心 <br />北京大学人民医院</p>
        </div>
        <div class="txtbox">
          <h4>学术指导单位</h4>
          <p>
            中国研究型医院学会血液净化专业委员会
            <br />国家卫生健康委能力建设和继续教育肾脏病学专家委员会
          </p>
        </div>
        <div class="txtbox no">
          <h4>承办单位</h4>
          <p>国医延长（北京）医学技术服务有限公司</p>
        </div>
      </div>
      <div class="right animate__animated wow animate__fadeInRight"></div>
    </div>
    <div class="bg animate__animated wow animate__fadeIn">
      <div class="title">
        <div class="titleCard">
          <p>活动背景</p>
          <span></span>
        </div>
      </div>
      <p>
        为进一步推进全国医疗卫生资源共享，充分挖掘全国肾内科教育资源，了解一线医生诊疗现状，促进循证医学在临床工作中的实践与应用，现计划通过病例征集的活动，遴选典型病例汇编成册，助力肾内科临床医学交流及经验分享。
      </p>
    </div>
    <!-- 活动目标 -->
    <div class="mubiao">
      <div class="title">
        <titleCard title="活动目标"></titleCard>
      </div>
      <div class="contentbox">
        <div
          class="box1 animate__animated wow animate__fadeInRight"
          data-wow-duration="0.8s"
        >
          <h2>01</h2>
          <p>
            围绕“病例”为核心，面向全国肾内科医生征集病例，通过活动开拓医生思维，提高医生的思辨能力及诊疗观念，借鉴他人治疗的经验并予以付诸实践交流，取长补短，共同提高。
          </p>
        </div>
        <div class="boxs">
          <div
            class="box2 animate__animated wow animate__fadeInRight"
            data-wow-duration="1.2s"
          >
            <h2>02</h2>
            <p>
              推广肾内科临床诊疗典型案例，引导促进肾内科临床诊疗的规范化。
            </p>
          </div>
          <div
            class="box3 animate__animated wow animate__fadeInRight"
            data-wow-duration="1.6s"
          >
            <h2>03</h2>
            <p>为诊疗方案寻求循证医学支持。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动要求 -->
    <div class="zhengji">
      <div class="title">
        <titleCard title="活动要求"></titleCard>
      </div>
      <div class="zhengjibox">
        <div class="left animate__animated wow animate__fadeInLeft">
          <img src="../../assets/image/Science/bingli/bingli3.webp" alt="" />
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <h3>征集对象</h3>
          <p>
            肾脏病相关科室<br />
            主治医师及以上卫生专业技术人员
          </p>
        </div>
      </div>
      <div class="zhengjibox">
        <div class="right right2 animate__animated wow animate__fadeInLeft">
          <h3>病例内容包括但不限于以下内容</h3>
          <p>
            1.原发性肾小球疾病；2.RPGN；3.血栓性微血管病；4.继发性肾小球病；5.遗传性或先天性肾脏病；6.肾小管疾病；7.间质性肾炎；8.妊娠相关肾脏病；9.急性肾损伤；10.慢性肾脏病一体化治疗典型病例；11.血液透析相关典型病例；12.腹膜透析相关典型病例；13.其他未归类的典型病例。
          </p>
        </div>
        <div class="left animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Science/bingli/bingli2.webp" alt="" />
        </div>
      </div>
      <div class="iosbox">
        <div class="left animate__animated wow animate__fadeInLeft">
          <img src="../../assets/image/Science/bingli/bingli3.webp" alt="" />
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <h3>征集对象</h3>
          <p>
            肾脏病相关科室<br />
            主治医师及以上卫生专业技术人员
          </p>
        </div>
      </div>
      <div class="iosbox">
        <div class="left animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Science/bingli/bingli2.webp" alt="" />
        </div>
        <div class="right right2 animate__animated wow animate__fadeInLeft">
          <h3>病例内容包括但不限于以下内容</h3>
          <p>
            1.原发性肾小球疾病；2.RPGN；3.血栓性微血管病；4.继发性肾小球病；5.遗传性或先天性肾脏病；6.肾小管疾病；7.间质性肾炎；8.妊娠相关肾脏病；9.急性肾损伤；10.慢性肾脏病一体化治疗典型病例；11.血液透析相关典型病例；12.腹膜透析相关典型病例；13.其他未归类的典型病例。
          </p>
        </div>
      </div>
    </div>
    <!-- 项目优势 -->
    <div class="youshi animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="项目优势"></titleCard>
      </div>
      <div class="contbox">
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon1.webp" alt="" />
          <h3>团队专业</h3>
          <p class="p1">由全国权威专家团队审核，<br />对每一份病例严格把关。</p>
          <p class="p2">由全国权威专家团队审核，对每一份病例严格把关。</p>
        </div>
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon2.webp" alt="" />
          <h3>覆盖面广</h3>
          <p class="p1">面向全国征集病例，<br />辐射面广。</p>
          <p class="p2">面向全国征集病例，辐射面广。</p>
        </div>
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon3.webp" alt="" />
          <h3>商业价值</h3>
          <p class="p1">
            全国范围内遴选病例，范围 <br />大，利于扩大产品知名度。
          </p>
          <p class="p2">全国范围内遴选病例，范围大，利于扩大产品知名度。</p>
        </div>
      </div>
      <p class="footertitle">
        经专家组评审后，征集结果将于9月<br />在“中国继续医学教育网”公布，并<br />将入围病例汇集成册，排版出书
      </p>
      <div class="tougao animate__animated wow animate__pulse">
        <a
          href="https://mp.weixin.qq.com/s/rYtHdz0LaY0UqJuhVHhaVA"
          target="_blank"
          >点击查看详情信息</a
        >
      </div>
    </div>
    <footerCard name="胡老师" phone="177-7786-7690">
      <template v-slot>
        <p class="email" style="padding-top:10px">投稿邮箱：snblzj@gytcare.com</p>
      </template>
    </footerCard>
  </div>
</template>

<script>
import titleCard from "../../components/title-card.vue";
import footerCard from '../../components/footer-card.vue'

export default {
  data() {
    return {};
  },
  created() {},
  components: {
    titleCard,
    footerCard
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.bingli {
  .bingli-title {
    padding: 1rem 0 1.5263rem 0;
  }
  .content {
    padding: 0 1.7895rem;
    height: 4.8632rem;
    display: flex;
    align-items: center;
    margin-bottom: 1.6421rem;
    @media screen and (max-width: 540px) {
      display: block;
      padding: 0 15px;
      height: 100%;
    }
    .left {
      flex: 1;
      .txtbox {
        margin-bottom: 0.6316rem;
        @media screen and (max-width: 540px) {
          margin-bottom: 27px;
        }
        h4 {
          color: #0ca6eb;
          font-size: 0.2947rem;
          margin: 0;
          margin-bottom: 0.2105rem;
          padding-left: 0.1263rem;
          border-left: 0.0737rem solid #0ca6eb;
          @media screen and (max-width: 540px) {
            font-size: 16px;
            border-left: 4px solid #0ca6eb;
          }
        }
        p {
          color: #333333;
          font-size: 0.2526rem;
          padding-left: 0.2rem;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
      }
      .no {
        margin-bottom: 0;
      }
    }
    .right {
      @media screen and (max-width: 540px) {
        height: 224px;
        width: 100%;
        margin-top: 40px;
      }
      width: 8.3684rem;
      height: 100%;
      background: url("../../assets/image/Science/bingli/bingli1.webp")
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .bg {
    height: 4.7368rem;
    width: 100%;
    background: url("../../assets/image/Science/bingli/bg1.webp") no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 300px;
      background-size: 150% 100%;
      background-position: 50% 0;
    }
    .title {
      padding: 0.9263rem 0 1.2316rem 0;
      @media screen and (max-width: 540px) {
        padding: 25px 0 40px 0;
      }
      .titleCard {
        text-align: center;
        p {
          padding-bottom: 0.3789rem;
          font-size: 0.4421rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.0526rem;
          @media screen and (max-width: 540px) {
            font-size: 21px;
            text-align: center;
          }
        }
        span {
          margin: 0 auto;
          position: relative;
          display: block;
          width: 3.0947rem;
          height: 0.0421rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 9.4737rem;
            height: 0.1263rem;
          }
        }
        span::after {
          content: "";
          position: absolute;
          left: 50%;
          margin-left: -0.2947rem;
          bottom: -0.0105rem;
          width: 0.5895rem;
          height: 0.0842rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 1.6842rem;
            height: 0.2211rem;
            margin-left: -0.8421rem;
          }
        }
      }
    }
    p {
      color: #ffffff;
      font-size: 0.2526rem;
      text-align: center;
      line-height: 0.4211rem;
      padding: 0 320px;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 26px;
        padding: 0 30px;
        text-align: left;
      }
    }
  }
  .mubiao {
    margin-bottom: 2.7368rem;
    .title {
      padding: 1.4316rem 0 0.9263rem 0;
    }
    .contentbox {
      margin: 0 1.7053rem;
      height: 5.6316rem;
      background: url("../../assets/image/Science/bingli/bg2.webp") no-repeat;
      background-size: 100% 100%;
      display: flex;
      // align-items: center;
      padding-top: 1.3263rem;
      box-sizing: border-box;
      @media screen and (max-width: 540px) {
        height: 100%;
        flex-wrap: wrap;
        margin: 0 15px;
        background: none;
      }
      h2 {
        margin: 0;
        padding-bottom: 0.4632rem;
        color: #0ca6eb;
        font-size: 0.8421rem;
        @media screen and (max-width: 540px) {
          font-size: 40px;
          padding-top: 25px;
        }
      }
      p {
        font-size: 0.2526rem;
        color: #666666;
        line-height: 0.4211rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          line-height: 26px;
        }
      }
      .box1 {
        padding: 0 0.7579rem;
        width: 7.3684rem;
        margin-right: 0.2105rem;
        // box-sizing: border-box;
        @media screen and (max-width: 540px) {
          height: 267px;
          flex-basis: 100%;
          flex-shrink: 0;
          box-sizing: border-box;
          margin-bottom: 10px;
          background: url("../../assets/image/Science/bingli/bg2.webp")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      .boxs {
        display: flex;
        @media screen and (max-width: 540px) {
          background: url("../../assets/image/Science/bingli/bg2.webp")
            no-repeat;
          background-size: 100% 100%;
          height: 210px;
          width: 100%;
        }
        .box2 {
          width: 2.7789rem;
          padding: 0 0.4211rem;
          @media screen and (max-width: 540px) {
            width: 52%;
          }
        }
        .box3 {
          @media screen and (max-width: 540px) {
            width: 40%;
          }
          padding: 0 0.4211rem;
          width: 2.5263rem;
          margin-left: 0.1579rem;
        }
      }
    }
  }
  .zhengji {
    padding-bottom: 0.8842rem;
    .title {
      padding-bottom: 1.8526rem;
    }
    .iosbox {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      padding: 0 15px;
      padding-bottom: 30px;

      .left {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 100%;
        box-sizing: border-box;
        padding-top: 20px;
        h3 {
          color: #0ca6eb;
          margin: 0;
          font-size: 16px;
          padding-bottom: 0.5263rem;
        }
        p {
          color: #666666;
          font-size: 15px;
          line-height: 25px;
        }
      }
    }
    .zhengjibox {
      @media screen and (max-width: 540px) {
        display: none;
      }
      display: flex;
      height: 3.6842rem;
      margin-bottom: 1.0526rem;
      justify-content: center;
      align-items: center;
      .left {
        width: 8.3684rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 8.3684rem;
        box-sizing: border-box;
        padding-left: 0.8842rem;

        h3 {
          color: #0ca6eb;
          margin: 0;
          font-size: 0.3368rem;
          padding-bottom: 0.5263rem;
        }
        p {
          color: #666666;
          font-size: 0.2105rem;
          line-height: 0.4211rem;
          padding-right: 96px;
        }
      }
      .right2 {
        padding-left: 0.5263rem;
      }
    }
  }
  .youshi {
    .title {
      padding-bottom: 0.9474rem;
    }
    .contbox {
      height: 5.5368rem;
      background-color: #fbfbfb;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 540px) {
        height: 195px;
      }
      .box {
        width: 3.5579rem;
        @media screen and (max-width: 540px) {
          width: 33%;
          height: 100%;
          padding: 0 10px;
        }
        padding: 0 1rem;
        text-align: center;
        img {
          width: 0.6316rem;
          height: 0.6421rem;
          @media screen and (max-width: 540px) {
            width: 22px;
            height: 22px;
            padding-top: 50px;
          }
        }
        h3 {
          margin: 0;
          padding: 0.8105rem 0 0.4421rem 0;
          color: #0ca6eb;
          font-size: 0.2947rem;
          @media screen and (max-width: 540px) {
            font-size: 15px;
          }
        }
        p {
          color: #666666;
          line-height: 0.4211rem;
          font-size: 0.2526rem;
        }
        .p1 {
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        .p2 {
          display: none;
          width: 90%;
          margin: 0 auto;
          line-height: 20px;
          @media screen and (max-width: 540px) {
            display: block;
            font-size: 12px;
          }
        }
      }
    }
    .footertitle {
      color: #272b2d;
      font-size: 0.2526rem;
      padding: 0.8632rem 0 1.2316rem 0;
      text-align: center;
      line-height: 0.4632rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 25px;
      }
    }
    .tougao {
      @media screen and (max-width: 540px) {
        height: 37px;
        line-height: 37px;
        width: 100%;
        background-size: 140% 100%;
        font-size: 12px;
        background-position: 52% 0;
      }
      width: 16.6316rem;
      height: 0.7895rem;
      line-height: 0.7895rem;
      margin: 0 auto;
      margin-bottom: 0.9579rem;
      display: flex;
      justify-content: center;
      background: url("../../assets/image/Science/zhuanxiang/zhuanxiang4.webp")
        no-repeat;
      background-size: 100% 100%;
      text-align: center;
      a {
        color: #0ca7eb;
        cursor: pointer;
        background-color: #fff;
        font-size: 0.2947rem;
        display: block;
        width: 373px;
        height: 75px;
        line-height: 75px;
        border: 1px solid #0ca7eb;
        @media screen and (max-width: 540px) {
          width: 150px;
          height: 36px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
